module.exports = __webpack_public_path__ + "static/media/illustration-footer.f1d7df9a.svg";